// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-radio input[type="radio"] {
  display: none;
}

.custom-radio input[type="radio"] + label {
  position: relative;
  padding: 10px;
  cursor: pointer;
  border-radius: 10px;
  transition: background-color 0.3s, color 0.3s;
}

.custom-radio input[type="radio"]:checked + label {
  background-color: #97e05b;
  color: #fff;
}
.materialLink:hover{
  color: #000;
}

.form-column {
  background-color: greenyellow;
  display: flex;
  flex-wrap: wrap;
}

.manage-course {
  flex: 1 1;
  margin: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/ManageContent/managecontent.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,WAAW;AACb","sourcesContent":[".custom-radio input[type=\"radio\"] {\n  display: none;\n}\n\n.custom-radio input[type=\"radio\"] + label {\n  position: relative;\n  padding: 10px;\n  cursor: pointer;\n  border-radius: 10px;\n  transition: background-color 0.3s, color 0.3s;\n}\n\n.custom-radio input[type=\"radio\"]:checked + label {\n  background-color: #97e05b;\n  color: #fff;\n}\n.materialLink:hover{\n  color: #000;\n}\n\n.form-column {\n  background-color: greenyellow;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.manage-course {\n  flex: 1;\n  margin: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
